"use client"

import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Navbar from "../../components/account/Navbar"
import Footer from "../../components/account/Footer"
import "./userProfileStyle.css"

const UserProfileEdit = () => {
  const navigate = useNavigate()
  const { userType } = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [profileData, setProfileData] = useState({
    name: "John Smith",
    username: "@johnsmith01",
    bio: "Pet lover and veterinary care enthusiast. Always here to help your furry friends stay healthy and happy!",
    location: "Central Park, New York",
    website: "https://petcareexpert.com",
    phone: "(650) 555-0123",
    email: "john.smith@petcare.com",
    avatar: "/images/profile-avatar.jpg",
    coverImage: "/images/cover-placeholder.jpg"
  })

  const [formData, setFormData] = useState(profileData)
  const [hasChanges, setHasChanges] = useState(false)
  const [avatarPreview, setAvatarPreview] = useState(null)
  const [coverPreview, setCoverPreview] = useState(null)

  useEffect(() => {
    // Check if form data has changed
    const hasFormChanges = JSON.stringify(formData) !== JSON.stringify(profileData)
    setHasChanges(hasFormChanges || avatarPreview || coverPreview)
  }, [formData, profileData, avatarPreview, coverPreview])

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }))
  }

  const handleAvatarUpload = (event) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        setAvatarPreview(e.target.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const handleCoverUpload = (event) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        setCoverPreview(e.target.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const handleSave = async () => {
    setIsLoading(true)
    try {
      // Here you would make API call to save profile data


      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000))

      // Navigate back to profile
      navigate(`/dashboard/${userType}/profile`)
    } catch (error) {
      console.error("Error saving profile:", error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleCancel = () => {
    navigate(`/dashboard/${userType}/profile`)
  }

  const getIconPlaceholder = (iconName, color = "#494949") => {
    switch (iconName) {
      case 'camera':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>
            <path d="M12 12m-3.2 0a3.2 3.2 0 1 1 6.4 0a3.2 3.2 0 1 1 -6.4 0" />
            <path d="M9 2l1.34 2.34L12 4l1.66 -1.66L15 2z" />
            <path d="M20 9v10a2 2 0 0 1 -2 2H6a2 2 0 0 1 -2 -2V9a2 2 0 0 1 2 -2h1l2 -3h4l2 3h1a2 2 0 0 1 2 2z" />
          </svg>
        )
      case 'edit':
        return (
          <svg width="16" height="16" viewBox="0 0 24 24" fill={color}>
            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
          </svg>
        )
      case 'user':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
          </svg>
        )
      case 'location':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
          </svg>
        )
      case 'website':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
          </svg>
        )
      case 'phone':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
          </svg>
        )
      case 'email':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
          </svg>
        )
      default:
        return null
    }
  }

  return (
    <div className="userprofileedit-container">
      {/* Header */}
      <Navbar currentUser={profileData} userType={userType} />

      {/* Main Content */}
      <div className="userprofileedit-main-content">
        {/* Page Header */}
        <div className="userprofileedit-page-header">
          <h1 className="userprofileedit-page-title">
            Edit Profile
          </h1>
          <p className="userprofileedit-page-subtitle">
            Update your profile information and preferences
          </p>
        </div>

        {/* Cover Photo Section */}
        <div
          className="userprofileedit-cover-section"
          style={{
            background: coverPreview ? `url(${coverPreview})` : (formData.coverImage ? `url(${formData.coverImage})` : 'linear-gradient(135deg, #8548A8 0%, #2A8AD2 100%)')
          }}
        >
          <div
            className="userprofileedit-cover-overlay"
            onClick={() => document.getElementById('cover-upload').click()}
          >
            {getIconPlaceholder('camera', '#FFFFFF')}
            <span className="userprofileedit-cover-text">
              Change Cover Photo
            </span>
          </div>
          <input
            id="cover-upload"
            type="file"
            accept="image/*"
            onChange={handleCoverUpload}
            style={{ display: 'none' }}
          />
        </div>

        {/* Profile Picture Section */}
        <div className="userprofileedit-profile-section">
          <div className="userprofileedit-avatar-container">
            <img
              src={avatarPreview || formData.avatar || "/icons/person.png"}
              alt="Profile"
              className="userprofileedit-avatar"
              onError={(e) => {
                e.target.src = "/icons/person.png"
              }}
            />
            <button
              onClick={() => document.getElementById('avatar-upload').click()}
              className="userprofileedit-avatar-edit-btn"
            >
              {getIconPlaceholder('edit', '#FFFFFF')}
            </button>
          </div>

          <input
            id="avatar-upload"
            type="file"
            accept="image/*"
            onChange={handleAvatarUpload}
            style={{ display: 'none' }}
          />

          <div>
            <h3 className="userprofileedit-profile-info-title">
              Profile Picture
            </h3>
            <p className="userprofileedit-profile-info-subtitle">
              Click the edit button to upload a new profile picture
            </p>
          </div>
        </div>

        {/* Form Fields */}
        <div className="userprofileedit-form-container">
          <h2 className="userprofileedit-section-title">
            Basic Information
          </h2>

          {/* Name Field */}
          <div className="userprofileedit-field-container">
            <label className="userprofileedit-field-label">
              {getIconPlaceholder('user', '#8548A8')}
              Full Name
            </label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              className="userprofileedit-input"
            />
          </div>

          {/* Username Field */}
          <div className="userprofileedit-field-container">
            <label className="userprofileedit-field-label">
              <span style={{ fontSize: '16px' }}>@</span>
              Username
            </label>
            <input
              type="text"
              value={formData.username}
              onChange={(e) => handleInputChange('username', e.target.value)}
              className="userprofileedit-input"
            />
          </div>

          {/* Bio Field */}
          <div className="userprofileedit-field-container">
            <label className="userprofileedit-field-label">
              📝 Bio
            </label>
            <textarea
              value={formData.bio}
              onChange={(e) => handleInputChange('bio', e.target.value)}
              rows={4}
              className="userprofileedit-textarea"
              placeholder="Tell people about yourself..."
            />
          </div>

          {/* Location Field */}
          <div className="userprofileedit-field-container">
            <label className="userprofileedit-field-label">
              {getIconPlaceholder('location', '#8548A8')}
              Location
            </label>
            <input
              type="text"
              value={formData.location}
              onChange={(e) => handleInputChange('location', e.target.value)}
              className="userprofileedit-input"
              placeholder="Enter your location"
            />
          </div>

          {/* Website Field */}
          <div className="userprofileedit-field-container">
            <label className="userprofileedit-field-label">
              {getIconPlaceholder('website', '#8548A8')}
              Website
            </label>
            <input
              type="url"
              value={formData.website}
              onChange={(e) => handleInputChange('website', e.target.value)}
              className="userprofileedit-input"
              placeholder="https://yourwebsite.com"
            />
          </div>

          {/* Contact Information Section */}
          <h3 className="userprofileedit-contact-section-title">
            Contact Information
          </h3>

          {/* Contact Information Grid */}
          <div className="userprofileedit-contact-grid">
            {/* Phone Field */}
            <div>
              <label className="userprofileedit-field-label">
                {getIconPlaceholder('phone', '#8548A8')}
                Phone
              </label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9\-\+\(\)\s]/g, '');
                  handleInputChange('phone', value);
                }}
                className="userprofileedit-input"
                placeholder="(555) 123-4567"
              />
            </div>

            {/* Email Field */}
            <div>
              <label className="userprofileedit-field-label">
                {getIconPlaceholder('email', '#8548A8')}
                Email
              </label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
                className="userprofileedit-input"
                placeholder="your.email@example.com"
              />
            </div>
          </div>

          {/* Privacy Settings */}
          <h3 className="userprofileedit-privacy-section-title">
            Privacy Settings
          </h3>

          <div className="userprofileedit-privacy-options">
            <label className="userprofileedit-checkbox-label">
              <input
                type="checkbox"
                defaultChecked
                className="userprofileedit-checkbox"
              />
              <span className="userprofileedit-checkbox-text">
                Make my profile public
              </span>
            </label>

            <label className="userprofileedit-checkbox-label">
              <input
                type="checkbox"
                defaultChecked
                className="userprofileedit-checkbox"
              />
              <span className="userprofileedit-checkbox-text">
                Allow others to find me by email
              </span>
            </label>

            <label className="userprofileedit-checkbox-label">
              <input
                type="checkbox"
                defaultChecked
                className="userprofileedit-checkbox"
              />
              <span className="userprofileedit-checkbox-text">
                Show my online status
              </span>
            </label>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="userprofileedit-actions">
          <button
            onClick={handleCancel}
            className="userprofileedit-cancel-btn"
          >
            Cancel
          </button>

          <button
            onClick={handleSave}
            disabled={!hasChanges || isLoading}
            className={`userprofileedit-save-btn ${hasChanges && !isLoading ? 'enabled' : 'disabled'}`}
          >
            {isLoading && (
              <div className="userprofileedit-loading-spinner" />
            )}
            {isLoading ? 'Saving...' : 'Save Changes'}
          </button>
        </div>

      </div>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default UserProfileEdit